var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{staticClass:"iframe_style",attrs:{"src":_vm.url,"height":"100%","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }